import React from 'react'
import { Redirect } from 'react-router-dom'

export default function checkUser(user) {
  if (!user) {
    return <Redirect to={{ pathname: "/login" }} />
  }
}
